import React, { Component } from "react";
import { leadType } from "../../app";
import FormStep from "../../common/components/formStep";
import BackContinueButton from "../../common/components/pageBlocks/backContinueButton";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import BankChargeAgree from "../../common/components/pageBlocks/loanDetails/bankChargeAgree";
import LoanDetailsForm from "../../common/components/pageBlocks/loanDetails/loanDetailsForm";
import LoanSummary from "../../common/components/pageBlocks/loanDetails/loanSummary";
import commonContext, { AppContext } from "../../common/context/common";
import { Utilities } from "../../common/utils/utilities";
import { Qm10SecApis } from "../apis/qm10SecApis";

interface IProps {
    history: any;
}
interface IState {
    LDIAgreeError: boolean;
}
export default class LoanDetails extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    apis: Qm10SecApis;
    setLead: Function;
    utils: Utilities;
    steps = [
        { title: "Vehicle" },
        { title: "Loan", active: true },
        { title: "Review" },
        { title: "Personal" },
        { title: "Confirmation" },
    ];
    constructor(props: IProps) {
        super(props);
        this.state = { LDIAgreeError: false };
    }
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.apis = (this.context as AppContext).apis as Qm10SecApis;
        this.setLead = (this.context as AppContext).setLead;
        this.lead = (this.context as AppContext).lead as leadType;
        this.utils = (this.context as AppContext).utils as Utilities;
        if (this.lead.amountPayable) {
            return;
        }
        let desiredLoanAmount: number = parseFloat(this.lead.loanAmt);
        const apiDataServ = await this.apis.getSarvSurakshaPremium({
            ...this.lead,
            tenure: (this.lead.tenure as unknown) as number,
        });
        const apisDatagetStampDuty = await this.apis.getStampDuty({
            ...this.lead,
            tenure: (this.lead.tenure as unknown) as number,
            loanAmount: desiredLoanAmount,
        });
        const emi = this.utils.getEmi(
            this.lead.interestRate,
            desiredLoanAmount,
            this.lead.tenure
        );
        let totalLoanAmount: number =
            desiredLoanAmount +
            (this.lead.roadTaxInsuranceAvailed
                ? parseFloat(this.lead.rtoEditAmount)
                : 0) +
            (this.lead.motorInsuranceAvailed
                ? parseFloat(this.lead.motorInsurancePremium)
                : 0) +
            (this.lead.dealerInsuranceAvailed
                ? parseFloat(this.lead.dealerInsuranceAmtEdit)
                : 0) +
            (this.lead.insuranceAvailed ? apiDataServ.result?.premium : 0);
        let totalAmount: number =
            totalLoanAmount -
            parseFloat(
                apisDatagetStampDuty?.result
                    ? apisDatagetStampDuty?.result?.stampDuty
                    : "0"
            ) -
            parseFloat(this.lead.processingFees) -
            this.lead.collateralCharges -
            (this.lead.motorInsuranceAvailed
                ? parseFloat(this.lead.motorInsurancePremium)
                : 0) -
            (this.lead.insuranceAvailed ? apiDataServ.result?.premium : 0);
        let marginMoneyPaid = parseFloat(this.lead.loanAmt) - desiredLoanAmount;
        this.setLead({
            desiredLoanAmount,
            desiredLoanAmountUpTo: desiredLoanAmount,
            loanAmtSelectedByUser: desiredLoanAmount,
            insuranceSsiPremium: apiDataServ.result?.premium,
            stampDuty: apisDatagetStampDuty.result
                ? apisDatagetStampDuty?.result?.stampDuty
                : 0,
            emi,
            finalCarPrice: parseFloat(this.lead.loanAmt),
            totalLoanAmount,
            totalAmount,
            marginMoneyPaid,
            liLoanAmount: desiredLoanAmount,
            liTenure: this.lead.liTenure
                ? this.lead.liTenure
                : this.lead.tenure,
            liEMI: this.lead.emi,
            liInterestRate: this.lead.interestRate,
            liPurposeLoan: "Personal",
            preApprovedLoanAmt: this.lead.loanAmt,
            insuranceName: "servSuraksha",
            insuranceAvailed: parseFloat(this.lead.tenure) > 60 ? false : true,
            state: this.lead.pdPresentState,
        });
    }
    handleOnSubmit = async (e) => {
        e.preventDefault();
        this.lead = (this.context as AppContext).lead as leadType;
        if (!this.lead.LDIAgree) {
            return this.setState({ LDIAgreeError: true });
        }
        await this.setLead({ loadingBtn: "loadingBtn" });
        const apiData = await this.apis.updateLoanInfo({
            ...this.lead,
            liTenure: (this.lead.liTenure as unknown) as string,
        });
        await this.setLead({ loadingBtn: "" });
        if (apiData.error?.error) {
            console.log(apiData.error);
        }
        if (apiData.result) {
            return this.props.history.push("/review");
        }
    };

    render() {
        this.lead = (this.context as AppContext).lead as leadType;

        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="vehicle-wrap mt-110">
                        <form onSubmit={(e) => this.handleOnSubmit(e)}>
                            <div className="container mx-auto px-5">
                                <FormStep steps={this.steps} />
                                <LoanDetailsForm />
                                <LoanSummary />
                                <BankChargeAgree
                                    error={this.state.LDIAgreeError}
                                />
                                <BackContinueButton backPath="/vehicle-details" />
                            </div>
                        </form>
                    </section>
                </div>
            </>
        );
    }
}
